import React from 'react';
import { motion } from 'framer-motion';
import { Star, Users, BookOpen, MapPin } from 'lucide-react';
export function SocialProofBar() {
  const stats = [{
    icon: <Users className="w-4 h-4 md:w-5 md:h-5" data-id="element-315" />,
    text: '+300 profesionales confían'
  }, {
    icon: <BookOpen className="w-4 h-4 md:w-5 md:h-5" data-id="element-316" />,
    text: '6+6 Tomos + Bonos'
  }, {
    icon: <div className="flex text-gold" data-id="element-317">
          <Star className="w-4 h-4 md:w-5 md:h-5 fill-current" data-id="element-318" />
          <Star className="w-4 h-4 md:w-5 md:h-5 fill-current" data-id="element-319" />
          <Star className="w-4 h-4 md:w-5 md:h-5 fill-current" data-id="element-320" />
          <Star className="w-4 h-4 md:w-5 md:h-5 fill-current" data-id="element-321" />
          <Star className="w-4 h-4 md:w-5 md:h-5 fill-current" data-id="element-322" />
        </div>,
    text: '4.9/5 valoración'
  }, {
    icon: <span className="text-lg md:text-xl leading-none" data-id="element-323">🇦🇷</span>,
    text: 'Todo el país'
  }];
  return <div className="bg-navy text-white py-4 md:py-8 border-y border-navy-400/20" data-id="element-324">
      <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8" data-id="element-325">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 divide-x-0 md:divide-x divide-white/10" data-id="element-326">
          {stats.map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex flex-col items-center text-center px-2 md:px-4 space-y-1 md:space-y-2" data-id="element-327">
              <div className="text-gold/90 mb-0.5 md:mb-1" data-id="element-328">{stat.icon}</div>
              <p className="font-medium text-[11px] md:text-base text-white/90 text-balance leading-tight md:leading-normal" data-id="element-329">
                {stat.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}